module.exports = __webpack_public_path__ + "/images/car.2f640.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/car.png
// module id = 298
// module chunks = 0